import React from "react"
import "./Radio.scss"
import Input from "../Input/Input";
import { bem } from "../../helpers";

export class Radio extends Input {
  inputType="radio"


  getId = () => {
    let s = []
    if (this.props.id) {
      s.push(this.props.id)
    }
    if (this.value()) {
      s.push(this.value())
    }
    return s.join(".") || "";
  }

  render() {
    let i = [this.name()]
    
    return (
      <>
        <input
          id={this.getId()}
          name={this.name()}
          type={this.inputType}
          value={this.value()}
          checked={this.props.checked}
          className={bem("field", "input")}
          disabled={this.props.disabled}
          {...this.inputProps}
          onChange={this.onChange}
        />
        <label
          htmlFor={this.getId()}
          {...this.labelProps}
          className={bem("field", "label")}
        >
          {this.props.label}
        </label>
      </>
    );
  }
}


Radio.propTypes = Input.propTypes
Radio.defaultProps = Input.defaultProps
export default Radio
